export const TIME_SEARCH_PARAMETERS_UPDATED = 'TIME_SEARCH_PARAMETERS_UPDATED_EVENT_TYPE'
